import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "mobx-react";
import RootStore from "./store";
import { Auth0Provider } from "@auth0/auth0-react";

ReactDOM.render(
  <Auth0Provider
    domain="newchart.us.auth0.com"
    clientId="dYhTLJpTgcUDTUoXIK4ypOXBeVKKs3PF"
    redirectUri={window.location.origin}
    cacheLocation="localstorage"
    audience="https://newchart.us.auth0.com/api/v2/"
    scope="read:current_user openid profile email"
  >
    <Provider
      authStore={RootStore.authStore}
      root={RootStore}
    >
      <App />
    </Provider>
  </Auth0Provider>,
  document.getElementById("root")
);
